/* React Imports */
import { useEffect, useRef, useState } from 'react';

/* CSS Imports */
import './styles/Home.css';


/* Components imports */
import Plx from "react-plx";
import { Focus1 } from "../components/Focus1";
import { Focus2 } from "../components/Focus2";
import { Focus3 } from "../components/Focus3";
import { Focus4 } from "../components/Focus4";
import { Focus5 } from "../components/Focus5";
import { FooterHome } from "../components/FooterHome";
import { Team } from "../components/Team";

const Home = (props) => {
    const myRef = useRef(null);
    // const isVisible = useOnScreen(myRef)
    function getWindowSize() {
        const {innerWidth, innerHeight} = window;
        return {innerWidth, innerHeight};
    }

    const [windowSize, setWindowSize] = useState(getWindowSize());

    useEffect(() => {
        function handleWindowResize() {
            setWindowSize(getWindowSize());
        }

        window.addEventListener('resize', handleWindowResize);

        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);

    const elt = document.querySelector('.Focus1_Container')
    function isInViewport(element) {
        if(!element){
            return false
        }
        const rect = element.getBoundingClientRect();
        console.log(rect.bottom <= 20)
        return (
            rect.bottom <= 20
        );
    }
    const [isVisible, setIsVisible] = useState(true);
    function logit() {
        setIsVisible(isInViewport(document.querySelector('.Header_Focus1_Container')));
    }
    useEffect(() => {
        function watchScroll() {
            window.addEventListener("scroll", logit);
        }
        watchScroll();
        return () => {
            window.removeEventListener("scroll", logit);
        };
    });

    return (
        <div class="Home_Container">
            
            <Focus1/>
            <Focus2/>
            <Focus3/>
            <Focus4/>
            <Team/>
            <Focus5/>

     

            <FooterHome
            myRef={myRef}
            />
            <a className="contact_icon_fix" href="https://linktr.ee/Sosjeunespousses" target="_blank">
                 <img src="https://i.ibb.co/tJKk788/contact-icon-removebg-preview.png" width='70'/>
                  </a>
        </div>
    )

};

export default Home;
// export default class Home extends React.Component {
//     render() {
//         return <h1>Hello, {this.props.name}</h1>;
//     }
// }

